import React from 'react';
import { motion } from 'framer-motion';
export function WakeUpCall() {
  return <section className="py-24 px-4 bg-zinc-900/50 border-y border-white/5" data-id="element-100" data-mp="17utuv4mrv5c9">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-101" data-mp="17x6inyf7o9x8">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-102" data-mp="p4lxz49o1b4i">
          Half of the year is gone. <br className="md:hidden" data-id="element-103" data-mp="u3ozieqfsz7q" />
          <span className="text-gray-500" data-id="element-104" data-mp="u2noubdc2eqj">Are you where you wanted to be?</span>
        </h2>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-105" data-mp="yvgv53og9v4q">
          <p data-id="element-106" data-mp="1f9mtyus2szk">
            Let's be honest. The first six months flowed by fast. If you're
            feeling more sluggish, foggy, and tired than you were in January,
            you're hitting the{' '}
            <strong className="text-white" data-id="element-107" data-mp="1rvwkq5amb54y">"Mid-Year Wall."</strong>
          </p>
          <p data-id="element-108" data-mp="1mwa5xrf55gu1">
            It's not a lack of discipline. It's biological friction.
            High-performers often stall midway through the year because their
            internal systems are overloaded with environmental toxins, poor
            sleep cycles, and mental fatigue.
          </p>
          <div className="border-l-4 border-green-500 pl-6 py-2 my-8 bg-green-500/5 rounded-r-lg" data-id="element-109" data-mp="194vmjjhbndmg">
            <p className="italic text-gray-300 font-medium" data-id="element-110" data-mp="145sio2d2vdg2">
              Most people will coast through the rest of the year and promise to
              "try again" in 2027. Do not be most people.
            </p>
          </div>
          <p data-id="element-111" data-mp="u8efh4g60l5p">
            The second half of 2026 is where the real results are made. This is
            your window to flush the system, recalibrate your engine, and turn
            the next 6 months into your most productive season ever.
          </p>
        </div>
      </motion.div>
    </section>;
}